<template>
    <div v-if="order.needs_refund" class="mt-3 alert alert-custom alert-light-primary" role="alert">
        <div class="alert-icon">
            <i class="fa fa-exclamation-triangle"/>
        </div>
        <div class="alert-text">
            Dieser Auftrag benötigt eine Rückerstattung des bereits erhaltenen Betrages!
        </div>
    </div>
</template>

<script>
export default {
    props: {
        order : Object
    }
};
</script>
